import React, { useEffect, useState } from "react";
import api from "../../api/axios";
import Input from "../ui/Input";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import ModelSelect from "../ui/ModelSelect";

const LaCoupe = () => {
  const [models, setModels] = useState([]);
  const [selectedModel, setSelectedModel] = useState("");
  const [chains, setChains] = useState([]);
  const [selectedChain, setSelectedChain] = useState("");
  const [value, setValue] = useState(0);
  const [entreValue , setEntreValue] = useState(0);
  const [totalValue, setTotalValue] = useState(0);
  const [entre , setEntre] = useState(0);

  useEffect(() => {
    const fetchModels = async () => {
      try {
        const response = await api.get("/models");
        setModels(response.data);
      } catch (error) {
        console.error("Error fetching models:", error);
      }
    };

    const fetchChains = async () => {
      try {
        const response = await api.get("/chains");
        setChains(response.data);
      } catch (error) {
        console.error("Error fetching chains:", error);
      }
    };

    fetchModels();
    fetchChains();
  }, []);

  const handleChainChange = (e) => {
    setSelectedChain(e.target.value);
  };

  const fetchCoupeProduction = async () => {
    if (selectedModel) {
      try {
        const response = await api.get(`/coupe_production/${selectedModel}`);
        setEntreValue(response.data);
        setTotalValue(0)
      } catch (error) {
        setTotalValue(0)
        setEntreValue(0)
        console.error("Error fetching CoupeProduction data:", error);
      }
    }

    if(selectedChain) {
      try {
        const response = await api.get(
          `/chain_production_sortie/${selectedModel}/${selectedChain}`
        );

        const { entre } = response.data;

        setEntre(parseInt(entre));
      } catch (error) {
        console.log(error);
      }
    }
  };

  useEffect(() => {
    fetchCoupeProduction();
  }, [selectedModel , selectedChain]);

  const handleModelChange = (e) => {
    setSelectedModel(e.target.value);
  };

  const onChange = (name, value) => {
    const newValue = value === "" ? 0 : parseInt(value, 10);

    if (isNaN(newValue)) {
      setValue(0);
      return;
    }

    setValue(newValue);
  };

  const handleSave = async () => {
    const selectedModelData = models.find((model) => model.id == selectedModel);
    const encour = selectedModelData.quantityReceived - totalValue - entreValue;

    if (encour < 0) {
      toast.error("Total Coupe can't be more than the encour");
      return;
    }

    try {
      await api.post(`/coupe_production/${selectedModel}`, {
        value: value,
      });
      setTotalValue(totalValue + value);
      setValue(0);  // Reset the input value after saving
      toast.success("Record saved successfully");
    } catch (error) {
      console.error("Error saving CoupeProduction data:", error);
    }
  };


  const handleUpdate = async () => {
    try {
     await api.post(`/coupe_production_update/${selectedModel}`, {
        value: value,
      });

      await fetchCoupeProduction();
      setValue(0);
      toast.success("Record updated successfully");
    } catch (error) {
      console.error("Error updating CoupeProduction data:", error);
    }
  }

  const handleReset = async () => {
    try {
      await api.delete(`/coupe_production/${selectedModel}`)
      setEntreValue(0)
      setTotalValue(0)
    } catch (error) {
      console.error("Error saving production data:", error);
    }
  }


  const selectedModelData = models.find((model) => model.id == selectedModel);

  return (
    <div className="ml-[19%] pt-[6rem]">
      <ToastContainer />
      <div className="flex items-center justify-between">
        <h2 className="text-xl font-semibold">La coupe</h2>
        <div className="ml-7 mb-4 pr-6 flex items-center w-[325px] justify-between">
          <ModelSelect className="mt-4" value={selectedModel} onChange={handleModelChange} models={models} />
          <select
            className="block w-fit mt-4 outline-0 p-[.5rem] border border-[#b3b3b3] focus:border-2 focus:border-[#2684ff] rounded"
            value={selectedChain}
            onChange={handleChainChange}
          >
            <option value="">Select Chain</option>
            {chains.map((chain, index) => (
              <option key={index} value={chain.id}>
                {chain.name}
              </option>
            ))}
          </select>
        </div>
      </div>
      {selectedModelData && (
        <div className="w-full pr-6">
          <div className="flex items-center justify-between">
            <h3 className="font-semibold text-xl">
              {selectedModelData.category}
            </h3>
            <h3 className="font-semibold text-xl">
              {selectedModelData.client}
            </h3>
          </div>
          <div className="flex my-5 items-center justify-between">
            <h3 className="font-semibold text-xl">
              Encour Coupe: {selectedModelData.quantityReceived - totalValue - entreValue}
            </h3>
            <h3 className="font-semibold text-xl">
              Entre Chain: {entre}
            </h3>
          </div>
          <div className="flex my-5 items-center justify-between">
              <h3 className="font-semibold text-xl">
                Total Coupe: {parseInt(totalValue) + parseInt(entreValue)}
              </h3>
              <button
                onClick={handleReset}
                className="mt-4 bg-red-500 text-white p-2 rounded"
                >
                Reset
              </button>
          </div>

        </div>
      )}
      {selectedModel && (
        <div className="flex flex-col p-5 mt-[2rem] mb-4 shadow-md w-fit p-1 rounded border">
          <Input
            handleChange={onChange}
            name={"coupe"}
            label="Total Coupe"
            text={value}
          />
            <div className="flex items-center justify-between">
            <button
                onClick={handleSave}
                className="mt-4 bg-blue-500 text-white p-2 rounded w-[48%]"
                >
                Save
              </button>
              <button
                onClick={handleUpdate}
                className="mt-4 bg-yellow-400 text-white p-2 rounded w-[48%]"
                >
                Modifier
              </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default LaCoupe;
